export class PriceGrantUnits
{
    public static readonly Organization:PriceGrantUnits = new PriceGrantUnits('organization');
    public static readonly User:PriceGrantUnits         = new PriceGrantUnits('user');
    public static readonly Application:PriceGrantUnits  = new PriceGrantUnits('application');

    private _value:string;

    constructor(value: string)
    {
        this._value = value;
    }

    public isEqualTo(priceGrantUnits:PriceGrantUnits):boolean
    {
        return priceGrantUnits && priceGrantUnits._value === this._value;
    }

    public static fromString(stringValue:string):PriceGrantUnits | null
    {
        if( PriceGrantUnits.Organization._value === stringValue )
            return PriceGrantUnits.Organization;
        else if( PriceGrantUnits.User._value === stringValue )
            return PriceGrantUnits.User;
        else if( PriceGrantUnits.Application._value === stringValue )
            return PriceGrantUnits.Application;
        else
            return null;
    }
}
